import React, { FC } from "react"

interface StatusTabsProps {
  activeStatus?: string
  counts?: {
    all: number
    pending: number
    confirmed: number
    callScheduled: number
    cancelled: number
  }
  onStatusChange?: (status: string) => void
}

const StatusTabs: FC<StatusTabsProps> = ({
  activeStatus = 'all',
  counts = {
    all: 0,
    pending: 0,
    confirmed: 0,
    callScheduled: 0,
    cancelled: 0
  },
  onStatusChange
}) => {
  const tabs = [
    { key: 'all', label: 'すべて', color: '' },
    { key: 'pending', label: '未承認', color: 'before:bg-status-pending' },
    { key: 'confirmed', label: '承認済み', color: 'before:bg-status-confirmed' },
    { key: 'call_scheduled', label: '架電予定', color: 'before:bg-status-call-scheduled' },
    { key: 'cancelled', label: 'キャンセル', color: 'before:bg-status-cancelled' }
  ]
  
  // タブのキーをcountsのキーにマッピング
  const getCount = (tabKey: string): number => {
    const keyMap: Record<string, keyof typeof counts> = {
      'all': 'all',
      'pending': 'pending',
      'confirmed': 'confirmed',
      'call_scheduled': 'callScheduled',
      'cancelled': 'cancelled'
    }
    return counts[keyMap[tabKey] || 'all'] || 0
  }

  return (
    <section className="mb-8">
      <div className="flex gap-2 flex-wrap">
        {tabs.map((tab) => {
          const isActive = activeStatus === tab.key
          return (
            <button
              key={tab.key}
              className={`flex items-center gap-2 px-5 py-3 border-2 rounded-xl cursor-pointer transition-all font-medium relative overflow-hidden ${
                isActive
                  ? 'bg-primary text-white border-primary shadow-md'
                  : 'bg-white border-gray-200 hover:border-primary hover:-translate-y-0.5 hover:shadow-md'
              } ${tab.color ? `${tab.color} before:content-[''] before:absolute before:left-0 before:top-0 before:bottom-0 before:w-1` : ''}`}
              onClick={() => onStatusChange?.(tab.key)}
            >
              <span>{tab.label}</span>
              <span
                className={`px-2 py-1 rounded-[10px] text-xs font-semibold min-w-[20px] text-center ${
                  isActive ? 'bg-white/20' : 'bg-accent text-white'
                }`}
              >
                {getCount(tab.key)}
              </span>
            </button>
          )
        })}
      </div>
    </section>
  )
}

export default StatusTabs

